import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/smartnodes`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.error('No se encontró un token válido.');
    throw new Error('Usuario no autenticado');
  }
  return { Authorization: `Bearer ${token}` };
};

export const getAllSmartnodes = async (token) => {
  try {
    const headers = getAuthHeaders(token);
    const response = await axios.get(`${API_URL}/all`, { headers });
    //console.log("Todos los Smartnodes obtenidos:", response.data);
    return response.data;
  } catch (error) {
    console.error('Error al obtener todos los Smartnodes:', error);
    throw error;
  }
};

export const getUserSmartnodes = async (token) => {
  try {
    const headers = getAuthHeaders(token);
    const response = await axios.get(`${API_URL}/user`, { headers });
    //console.log("Smartnodes del usuario obtenidos:", response.data);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los Smartnodes del usuario:', error);
    throw error;
  }
};

export const addSmartnodeToUser = async (smartnodeId, token) => {
  try {
    const headers = getAuthHeaders(token);
    const response = await axios.post(`${API_URL}/user`, { smartnodeId }, { headers });
    console.log("Smartnode añadido (response completa):", response);
    return response; 
  } catch (error) {
    //console.error('Error al añadir el Smartnode al usuario:', error);
    throw error;
  }
};

export const removeSmartnodeFromUser = async (smartnodeId, token) => {
  try {
    const headers = getAuthHeaders(token);
    const response = await axios.delete(`${API_URL}/user`, { headers, data: { smartnodeId } });
    //console.log("Smartnode eliminado (response completa):", response);
    return response;
  } catch (error) {
    console.error('Error al eliminar el Smartnode del usuario:', error);
    throw error;
  }
};
